import React, { FC } from 'react'
import { Divider, csx } from '@vtex/admin-ui'
import { injectIntl, FormattedMessage } from 'react-intl'

import DefaultButton from '@/checkout-instore-legacy/components/Commons/Topbar/DefaultButton'

type PageModalProps = {
  titleId: string
  isOpen: boolean
  type: string
  setIsOpen: (isOpen: boolean) => void
}

const PageModal: FC<PageModalProps> = ({
  titleId,
  isOpen,
  setIsOpen,
  children,
}) => {
  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <div
      className={csx({
        position: 'fixed',
        overflow: 'scroll',
        top: '$space-0',
        right: '$space-0',
        bottom: '$space-0',
        left: '$space-0',
        zIndex: 9999,
        pointerEvents: isOpen ? 'all' : 'none',
        backgroundColor: isOpen ? '#fff' : 'transparent',
        display: 'block',
        tabIndex: 0,
      })}
    >
      {isOpen && (
        <div
          className={csx({
            position: 'absolute',
            zIndex: 9999,
            backgroundColor: '#fff',
            width: '100%',
            overflow: 'scroll',
          })}
        >
          <div
            className={csx({
              flex: 'none',
            })}
            data-testid={`page-modal-title-${titleId}`}
          >
            <div>
              <div
                className={csx({
                  backgroundColor: '#fff',
                  borderColor: 'rgba(0,0,0,.2)',
                  display: 'flex',
                  flexDirection: 'column',
                })}
              >
                <div
                  className={csx({
                    paddingTop: '0.75rem',
                    paddingBottom: '0.75rem',
                  })}
                >
                  <div
                    className={csx({
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-between',
                      paddingBottom: '0.75rem',
                    })}
                  >
                    <div
                      className={csx({
                        display: 'flex',
                        flex: '1 1 auto',
                        minWidth: 0,
                        minHeight: 0,
                        alignItems: 'center',
                      })}
                    >
                      <DefaultButton
                        id="about-back"
                        icon="back"
                        onClick={() => handleClose()}
                      />
                      <div
                        className={csx({
                          position: 'relative',
                          display: 'flex',
                          flex: '1 1 auto',
                          minWidth: 0,
                          minHeight: 0,
                          alignItems: 'center',
                          height: '100%',
                          width: '100%',
                        })}
                      >
                        <div
                          className={csx({
                            fontSize: '1.25rem',
                            flex: '1 1 0%',
                            userSelect: 'none',
                          })}
                        >
                          <FormattedMessage id={titleId} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider />
                </div>
              </div>
            </div>
          </div>
          {children}
        </div>
      )}
    </div>
  )
}

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
export default injectIntl(PageModal)
